<template>
    <div>
        <v-card v-if="profile && profile.status != 'unregistered' ">
            <v-card-title>Xperience Profil</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-select v-model="profile.type" label="Type" :items="types"></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field v-model="profile.credit" label="Credit"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field v-model="profile.code" label="Security Code"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field v-model="profile.door_card" label="Door Card Number"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn outlined color="warning" @click=sendCredential>Send credential</v-btn>
                <v-spacer></v-spacer>
                <v-btn outlined color="accent" @click=save>Save Profile</v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-else>
            <v-card-title>Xperience Profil</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-select v-model="pack" label="Pack" :items="types"></v-select>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined color="accent" @click=activate>Create Invoice for this package</v-btn>
            </v-card-actions>
        </v-card>
    </div>

</template>

<script>
import { mapActions } from 'vuex'
export default {
    props:{
        clientId:{
            type:Number,
            required:true
        }
    },
    data: () => ({
        pack:null,
        profile:null,
        types:[
            {text:'Non Member', value:'nonMember'},
            {text:'Standard', value:'standard'},
            {text:'Premium', value:'premium'},
            {text:'Premium DUO', value:'premiumduo'},
        ]
    }),
    mounted(){
        this.init();
    },
    methods:{
        ...mapActions("schedulerProfile", {getSchedulerProfile: 'view', saveSchedulerProfile: 'update', subscribePackage: 'create', credential: 'credential'}),
        init(){
            this.getSchedulerProfile({clientId:this.clientId})
            .then((data)=>{
                this.profile = data;
            })
        },
        save(){
            this.saveSchedulerProfile({
                clientId:this.clientId,
                profile:this.profile
            })
            .then((data) => {
                console.log(data)
            })
        },
        sendCredential(){
            this.credential(this.clientId)
            .then((data) => {
                console.log(data)
            })
        },
        activate(){
            this.subscribePackage({
                clientId:this.clientId,
                profile:this.pack
            })
            .then((data) => {
                if(data.id){
                    this.$router.push("/orders/view/"+data.id)
                }else{
                    this.init()
                }
            })
        }
    }
}
</script>

<style>

</style>